import { render, staticRenderFns } from "./intro.vue?vue&type=template&id=53043e6b&"
import script from "./intro.vue?vue&type=script&lang=ts&"
export * from "./intro.vue?vue&type=script&lang=ts&"
import style0 from "./intro.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports